import React from 'react';

const StageDistribution = ({ data }) => {
  const stages = Object.keys(data);
  const total = Object.values(data).reduce((sum, count) => sum + count, 0);

  const stageColors = {
    'Discovery': 'bg-gray-500 dark:bg-gray-500',
    'Qualification': 'bg-blue-500 dark:bg-blue-500',
    'Proposal': 'bg-purple-500 dark:bg-purple-500',
    'Negotiation': 'bg-orange-500 dark:bg-orange-500',
    'Closed Won': 'bg-green-500 dark:bg-green-500',
    'Closed Lost': 'bg-red-500 dark:bg-red-500'
  };

  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Stage Distribution</h3>
      <div className="space-y-3">
        {stages.map((stage) => {
          const count = data[stage];
          const percentage = total > 0 ? (count / total) * 100 : 0;
          
          return (
            <div key={stage} className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <div className={`w-3 h-3 rounded-full ${stageColors[stage] || 'bg-gray-500'}`} />
                <span className="text-sm text-gray-700 dark:text-gray-300">{stage}</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-sm font-medium text-gray-900 dark:text-gray-200">{count}</span>
                <span className="text-xs text-gray-500 dark:text-gray-400">({percentage.toFixed(0)}%)</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StageDistribution;